console.log("hello");

const header_html = $(".menu")[0].outerHTML;
// document ready
$(function () {
  var isMobile = false; //initiate as false
  // device detection
  if (
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
      navigator.userAgent
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      navigator.userAgent.substr(0, 4)
    )
  ) {
    isMobile = true;
  }
  var $sticky = $(".sticky");
  var $stickyTo = $(".stickyTo");

  $(document.body).on("touchmove", onScroll); // for mobile
  $(window).on("scroll", onScroll);
  function onScroll() {
    /* Sticky scrolling logic */
    if ($sticky?.length && $stickyTo?.length) {
      var stickyToTop = $stickyTo.offset().top;
      var stickyToBottom = stickyToTop + $stickyTo.outerHeight();
      var scroll = window.pageYOffset + document.body.scrollTop;
      var stickyTop = $sticky.offset().top - 100;
      var stickyBottom = stickyTop + $sticky.outerHeight();

      if (stickyBottom >= stickyToBottom) {
        if (scroll < stickyTop) {
          $sticky.addClass("fixed").removeClass("abs");
        } else {
          $sticky.addClass("abs");
        }
      } else if (scroll > stickyToTop) {
        $sticky.addClass("fixed");
      } else if (scroll < stickyToTop) {
        $sticky.removeClass("abs").removeClass("fixed");
      }
    }
    // fade in effect check
    checkPosition();
  }

  // fade in on view enter
  var elements;
  var windowHeight;

  function init() {
    elements = $(".hidden");
    windowHeight = window.innerHeight;
  }

  function checkPosition() {
    for (var i = 0; i < elements.length; i++) {
      var element = $(elements[i]);
      var positionFromTop = element[0].getBoundingClientRect().top;

      if (positionFromTop - windowHeight <= 0) {
        element.addClass("fade-in-element");
        element.removeClass("hidden");
      }
    }
  }

  window.addEventListener("resize", init);

  init();
  checkPosition();

  $(".top-bar .close").click(function () {
    $(".top-bar").fadeOut(600, function () {
      $(this).remove();
      $(".menu").css({ top: 0 });
      $("main#main").addClass("no-top-bar");
    });
  });

  const topMessagesContainer = $(".top-bar");
  const topMessagesInterval =
    (parseFloat(topMessagesContainer.data("timeInterval")) || 5) * 1000;
  let topMessages = topMessagesContainer.data("topMessages");
  let currentMessageIndex = 0;
  let totalMessages = 0;
  if (topMessagesContainer && topMessagesContainer.length) {
    topMessages = topMessages
      .replace(/^(?:[\t ]*(?:\r?\n|\r))+/, "\n")
      .split("\n")
      .filter((x) => x != "<br />")
      .map((x) => x.replace(/\<br \/>/g, ""));
    if (topMessages && topMessages.length) {
      totalMessages = topMessages.length;
      setTopMessage();
      setInterval(function () {
        setTopMessage();
      }, topMessagesInterval);
    }
  }

  function setTopMessage() {
    var msg = topMessages[currentMessageIndex++ % totalMessages];
    var msg_obj = msg.split("|");
    var licon = msg_obj[0] || "";
    var text = msg_obj[1] || "";
    var color = msg_obj[2] || "";
    var ricon = msg_obj[3] || "";

    // animate switch
    topMessagesContainer.find(".card").removeClass("active");
    setTimeout(function () {
      topMessagesContainer.find("#licon").removeClass().addClass(licon);
      topMessagesContainer.find(".text").html(text).css({ color: color });
      topMessagesContainer.find("#ricon").removeClass().addClass(ricon);
      topMessagesContainer.find(".card").addClass("active");

      // reset variables
      licon = text = color = ricon = "";
    }, 400);
  }

  $(document).on("click", ".policies-links > a", function (ev) {
    window.open(
      this.href,
      "window",
      "toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=600px, height=100" +
        window.innerHeight +
        ""
    );
    ev.stopPropagation();
    ev.preventDefault();
  });

  $("#shopify-section-cart-template .cart__submit").click(function () {
    gtag('event', 'conversion', {
      'send_to': 'AW-460594678/ATWoCKCEk-0BEPa70NsB',
      'value': 0.0,
      'event_callback': callback
    });
  });

  // menu
  $(document).on("click", ".mobile-menu", function () {
    $(this).toggleClass("open");
    $(".menu .menu-items").toggleClass("open");
  });

  if (window.location.pathname.startsWith("/cart")) {
    $(".coupons").removeClass("hide");
  }

  // coupon code
  $(document).on("click", ".copy-coupon button", function () {
    var copyText = $(this).parents(".copy-coupon").find(".tp_coupon_code")[0];
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand("copy");
    var tooltip = $(this).find(".tooltiptext");
    tooltip.html("Copied: " + copyText.value);
    setTimeout(function () {
      $(".close-coupons").click();
    }, 1000);
  });

  $(document).on("mouseout", ".copy-coupon button", function () {
    var tooltip = $(this).find(".tooltiptext");
    tooltip.html("Copy to clipboard");
  });

  $(document).on("click", ".close-coupons", function (e) {
    var coupons = $(this).parents(".coupons");
    var tooltip = $(this).parent().find(".tooltiptext");
    coupons.toggleClass("close");
    $(".page-width").toggleClass("with-coupons");
    coupons.find(".coupons-title-open").toggleClass("hide");
    coupons.find(".coupons-title-close").toggleClass("hide");
    if (coupons.hasClass("close")) {
      tooltip.html("Show Coupons");
    } else {
      tooltip.html("Hide Coupons");
    }
  });

  var currentCarouselTranslate = 0;
  var maxTranslate = 620;
  $(document).on("click", ".coupons-items .btn", function () {
    var btn = $(this);
    var sibling = btn.siblings(".btn");
    sibling.removeAttr("disabled");
    sibling.css("pointer-events", "all");
    var isLeft = btn.hasClass("btn-left");
    if (isLeft) {
      currentCarouselTranslate += 620;
    } else {
      currentCarouselTranslate -= 620;
    }

    if (currentCarouselTranslate >= maxTranslate) {
      currentCarouselTranslate = maxTranslate;
    } else if (currentCarouselTranslate <= -maxTranslate) {
      currentCarouselTranslate = -maxTranslate;
    } else {
      btn.removeAttr("disabled");
      btn.css("pointer-events", "all");
    }

    if (Math.abs(currentCarouselTranslate) >= maxTranslate) {
      btn.attr("disabled", "disabled");
      btn.css("pointer-events", "none");
    }

    $(".coupons-items").animate({
      "margin-left": currentCarouselTranslate + "px",
    });
  });
  // $(".coupons-items").addEventListener('touchstart', handleTouchStart, false);
  // $(".coupons-items").addEventListener('touchmove', handleTouchMove, false);


  $(window).on('load', function() {
    $('.hide-while-loading').css('visibility', 'visible');
    $(".se-pre-con").fadeOut("slow");
    
    if (window.location.pathname.search(/\/policies.*/) > -1) {
      $("main").prepend(header_html).css({ "margin-top": "105px" });
      $(".menu").css({ top: 0 });
      setTimeout(function () {
        $(".doubly-float").css({top: '5px' });
      }, 400);
      $(".top-bar").addClass("hide");
    }
  });

});

function updateTooltip(elem, message) {
  $(elem).text(message);
}

function swipeHandler(event, isLeft) {
  console.log("event:" + event + " isLeft: " + isLeft);
}

var xDown = null;
var yDown = null;

function getTouches(evt) {
  return (
    evt.touches || // browser API
    evt.originalEvent.touches
  ); // jQuery
}

function handleTouchStart(evt) {
  const firstTouch = getTouches(evt)[0];
  xDown = firstTouch.clientX;
  yDown = firstTouch.clientY;
}

function handleTouchMove(evt) {
  if (!xDown || !yDown) {
    return;
  }

  var xUp = evt.touches[0].clientX;
  var yUp = evt.touches[0].clientY;

  var xDiff = xDown - xUp;
  var yDiff = yDown - yUp;

  if (Math.abs(xDiff) > Math.abs(yDiff)) {
    /*most significant*/
    if (xDiff > 0) {
      /* left swipe */
      console.log("left swipe");
    } else {
      /* right swipe */
      console.log("right swipe");
    }
  } else {
    if (yDiff > 0) {
      /* up swipe */
      console.log("up swipe");
    } else {
      /* down swipe */
      console.log("down swipe");
    }
  }
  /* reset values */
  xDown = null;
  yDown = null;
}
